export { default } from './container';


// WEBPACK FOOTER //
// ./components/Agile/organisation/index.js